import { useState } from 'react';
import { TextField, Box } from '@mui/material';

interface TextItemFormProps {
  onDataChange: (data: { title: string; content: string }) => void;
}

export default function TextItemForm({ onDataChange }: TextItemFormProps) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="Title"
        value={title}
        onChange={(e) => {
          setTitle(e.target.value);
          onDataChange({ title: e.target.value, content });
        }}
        fullWidth
        required
      />
      <TextField
        label="Text"
        value={content}
        onChange={(e) => {
          setContent(e.target.value);
          onDataChange({ title, content: e.target.value });
        }}
        multiline
        rows={4}
        fullWidth
        required
      />
    </Box>
  );
}
